import useDataTable from "hooks/useDataTable";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";
import locale from "localization/en";
import styles from "../cash-noncash.module.scss";
import { DataTableV2, Title } from "components/commons";
import { useMemo } from "react";
import { promoSumaryColumn } from "./promo-summary-column";
import { promoSummaryMapper } from "./promo-summary.mapper";

const ShiftDetailsPromoSummary = ({ shift }) => {
  const sortedPromos = useMemo(() => {
    const result = shift?.promos || [];

    return result
      .sort((a, b) => {
        const aIsNumber = typeof a.discount === "number";
        const bIsNumber = typeof b.discount === "number";

        if (aIsNumber && bIsNumber) return a.discount - b.discount;
        if (!aIsNumber && !bIsNumber) return a.discount.localeCompare(b.discount);
        return aIsNumber ? -1 : 1;
      })
      .reduce((acc, item) => {
        const existing = acc.find((x) => x.type === item.type);

        if (existing) {
          existing.totalQuantities += item.totalQuantities;
          existing.totalTransactions += item.totalTransactions;
        } else {
          acc.push({ ...item });
        }

        return acc;
      }, []);
  }, [shift?.promos]);

  const { table } = useDataTable({
    value: sortedPromos || [],
    filter: { initialState: initialShiftRecordFilterState(), mapper: (data) => data },
    table: {
      key: "promos",
      mapper: (val) => promoSummaryMapper({ val, shiftId: shift?.shift?.shiftId }),
      columns: promoSumaryColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.promoSummary}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsPromoSummary;
